<div *ngIf="isFetchingUser; else content" class="flex flex-col gap-24">
  <span class="shimmer !w-200 !h-40"></span>
  <span class="shimmer"></span>

  <div *ngFor="let shimmer of shimmersIterable">
    <span class="shimmer !w-64"></span>
    <span class="shimmer !h-40"></span>
  </div>

  <span class="shimmer !h-40"></span>
  <span class="shimmer !h-40"></span>
</div>

<ng-template #content>
  <h1>{{ 'REGISTER.WELCOME' | translate }}</h1>
  <p class="font-semi-bold text-md mb-0 mt-8">{{ 'REGISTER.SIGN_UP_TO_ACCESS' | translate }}</p>

  <form class="mt-24 flex flex-col gap-24" [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="group">
      <label for="sign-up-form--input--name">{{ 'REGISTER.NAME' | translate }}</label>
      <input
        tsqTextInput
        id="sign-up-form--input--name"
        formControlName="name"
        name="first-name"
        autocomplete="off"
        class="control font-base"
        schema="new-primary"
      />
    </div>

    <div class="group">
      <label for="sign-up-form--input--last-name">{{ 'REGISTER.LAST_NAME' | translate }}</label>
      <input
        tsqTextInput
        id="sign-up-form--input--last-name"
        formControlName="lastName"
        name="last-name"
        autocomplete="off"
        class="control font-base"
        schema="new-primary"
      />
    </div>

    <div class="group">
      <label for="sign-up-form--input--password">{{ 'REGISTER.PASSWORD' | translate }}</label>
      <input
        tsqPeekablePassword
        id="sign-up-form--input--password"
        formControlName="password"
        name="password"
        type="password"
        autocomplete="new-password"
        class="control font-base"
        schema="new-primary"
        [errorMessage]="errorMessage$ | async | translate"
      />

      <div class="text-coal-secondary mt-4 text-sm">
        <comm-password-requirements
          [requirements]="passwordRequirements$ | async"
          [showIcon]="form.controls.password.touched"
        />
      </div>
    </div>

    <div class="group">
      <label for="sign-up-form--input--confirm-password">
        {{ 'REGISTER.CONFIRM_PASSWORD' | translate }}
      </label>
      <input
        tsqPeekablePassword
        id="sign-up-form--input--confirm-password"
        formControlName="confirmPassword"
        name="confirm-password"
        type="password"
        autocomplete="new-password"
        class="control font-base"
        schema="new-primary"
        [errorMessage]="'PASSWORD.REQUIREMENTS.DONT_MATCH' | translate"
      />
    </div>

    <tsq-button
      *ngIf="!isRegistering; else loader"
      schema="new-primary"
      size="lg"
      type="submit"
      [text]="'REGISTER.SIGN_UP' | translate"
      [disabled]="form.invalid"
    />

    <ng-template #loader>
      <tsq-small-loader class="h-40" />
    </ng-template>
  </form>

  <tsq-button
    class="mt-16"
    schema="new-primary"
    size="lg"
    kind="tertiary"
    route="login"
    [text]="'REGISTER.BACK_TO_LOGIN' | translate"
    [disabled]="isRegistering"
    (clicked)="goBack.emit()"
  />
</ng-template>
